import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/Common/Breadcrumb.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/Technology/Technologysection.tsx")